const parseApiFormErrors = (formErrors) => Object.fromEntries(Object.entries(formErrors).map(([field, value]) => (
    [field, { message: value }]
)));

export default parseApiFormErrors;